import { $t } from '@/translations';
import { OrderStatuses, OrderTypes } from '@/core/enums';
import { isOrderTypeBusiness } from '../consumer-orders/OrderStatuses';

const holdEnabled = `${process.env.VUE_APP_GLOBAL_HOLD_ENABLED}`;
const convertEnabled = `${process.env.VUE_APP_ORDER_CONVERT_ENABLED}`;
const editDeleteEnabled = `${process.env.VUE_APP_ORDER_EDIT_DELETE_ENABLED}`;

export function isHoldEnabled() {
    return holdEnabled === 'true';
}

export function isConvertEnabled() {
    return convertEnabled === 'true';
}

export function isEditDeleteEnabled() {
    return editDeleteEnabled === 'true';
}

const labels = {};

labels[OrderStatuses.Accepted] = $t('businessOrders.labels.statuses.accepted');
labels[OrderStatuses.InFulfillment] = $t('businessOrders.labels.statuses.inFulfillment');
labels[OrderStatuses.Shipped] = $t('businessOrders.labels.statuses.shipped');
labels[OrderStatuses.Backordered] = $t('consumerOrders.labels.statuses.backordered');

if (isHoldEnabled()) {
    labels[OrderStatuses.OnHold] = $t('consumerOrders.labels.statuses.held');
}

labels[OrderStatuses.PackingComplete] = $t('businessOrders.labels.statuses.packingComplete');
labels[OrderStatuses.ReadyForPickup] = $t('businessOrders.labels.statuses.readyForPickup');
labels[OrderStatuses.AllOrders] = $t('businessOrders.labels.statuses.allOrders');

const typeLabels = {};

typeLabels[OrderTypes.Business] = $t('businessOrders.labels.types.bec');
typeLabels[OrderTypes.EDIWholesale] = $t('businessOrders.labels.types.ediWholesale');
typeLabels[OrderStatuses.AllOrders] = $t('businessOrders.labels.statuses.allOrders');

export const BusinessOrderStatusLabels = labels;

export const BusinessOrderTypeLabels = typeLabels;

export function isBackorder(order) {
    return order.status === OrderStatuses.Backordered;
}

export function isHeld(order) {
    return order.status === 'OnHold';
}

export function isPackingComplete(order) {
    return order.status === 'Packing Complete';
}

export function isReadyForPickup(order) {
    return order.status === 'Ready For Pickup';
}

export function canBeDeleted(order) {
    return isEditDeleteEnabled() && (order.status === OrderStatuses.Accepted
        || order.status === OrderStatuses.OnHold);
}

export function canBeEdited(order) {
    return isEditDeleteEnabled() && isOrderTypeBusiness(order) && (order.status === OrderStatuses.Accepted
        || order.status === OrderStatuses.InFulfillment
        || order.status === OrderStatuses.ReadyForPickup
        || order.status === OrderStatuses.PackingComplete
        || isBackorder(order)
        || order.status === OrderStatuses.OnHold);
}

export function canBeHeld(order) {
    return order.status === OrderStatuses.Accepted
        && order.orderType !== OrderTypes.EDIWholesale
        && isHoldEnabled();
}

export function canBeReleased(order) {
    return order.status === OrderStatuses.OnHold
        && isHoldEnabled();
}

export default OrderStatuses;
